import { Select } from "antd";
import { FC } from "react";

const SelectRoleField: FC<any> = (props: any) => {
  return (
    <Select {...props}>
      <Select.Option key="admin" >مدیر</Select.Option>
      <Select.Option key="user" >کاربر</Select.Option>
    </Select>
  )
}

export default SelectRoleField
